const StatAbbreviations = Object.freeze({
	CHAR_LEVEL: 'lvl',
	AVG_ITEM_LEVEL: 'ilv',
	LEVEL: 'ilv',
	LEG_CLOAK: 'rnk',
	AZERITE: 'aze',
	ARMOR: 'arm',
	AGILITY: 'agi',
	INTELLECT: 'int',
	STAMINA: 'sta',
	STRENGTH: 'str',
	VERSATILITY: 'versa',
	CRIT_RATING: 'crit',
	HASTE_RATING: 'haste',
	MASTERY_RATING: 'mast',
	CORRUPTION: 'corr',
	CORRUPTION_RESISTANCE: 'corr res',
	COMBAT_RATING_LIFESTEAL: 'leech',
	COMBAT_RATING_SPEED: 'speed',
	COMBAT_RATING_AVOIDANCE: 'avoid'
});

export default StatAbbreviations;
